let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("buj9L")).then(() => parcelRequire('2EuJ7'));